<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item label="物料名称">
          <el-autocomplete
            :popper-append-to-body="false"
            v-model="productName"
            :fetch-suggestions="querySearch"
            placeholder="请输入物料名称"
            @select="(item) => handleSelect(item)"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.productName }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item prop="productBatchNum" label="批次号">
          <el-input
            v-model="listForm.data.productBatchNum"
            placeholder="请输入批次号"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-row :gutter="10">
      <el-col :span="1.5" class="add-btn">
        <el-upload
          class="upload-demo"
          ref="upload"
          action=""
          :show-file-list="false"
          :http-request="uploadFile"
          :on-success="handleSuccess"
        >
          <el-button
            slot="trigger"
            icon="el-icon-upload2"
            size="small"
            type="primary"
            >导入入库文件</el-button
          >
        </el-upload>
      </el-col>
    </el-row> -->
    <el-table :data="list" v-loading="loading" border>
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productName"
        label="物料名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="pakageSpec" label="规格" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.productionProduct">{{ scope.row.productionProduct.specifications }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productBatchNum"
        label="批次号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="入库袋数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="totalWeight"
        label="入库重量（吨）"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="inStorageNum"
        label="组盘袋数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="successRateStr"
        label="组盘成功率"
        align="center"
      ></el-table-column>
      <el-table-column prop="madeDate" label="生产日期" align="center">
        <template slot-scope="scope">
          {{ scope.row.madeDate | dateformat }}
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="入库日期" align="center">
        <template slot-scope="scope">
          {{ scope.row.createDate | dateformat }}
        </template></el-table-column
      >
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-view"
            @click="operationBtn(1, scope.row)"
            >详细信息</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, total"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      title="详细信息"
      :visible.sync="dialogInfo"
      :close-on-click-modal="false"
      @close="handleAddClose"
    >
      <el-form
        :model="productInfo"
        ref="productInfo"
        label-width="120px"
        v-if="productInfo"
        class="dialog-Info"
      >
        <h3 class="info-title">物料信息</h3>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物料名称：" prop="physicDetailType">
              <span>{{ productInfo.productName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料编号：" prop="dosageForm">
              <span v-if="productInfo.productionProduct">{{
                productInfo.productionProduct.productionType.productTypeName
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物料类型：" prop="dosageForm">
              <span v-if="productInfo.productionProduct">{{
                productInfo.productionProduct.productionType.productTypeName
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌：">
              <span v-if="productInfo.productionProduct">{{
                productInfo.productionProduct.productBrand
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物料规格：">
              <span v-if="productInfo.productionProduct">{{
                productInfo.productionProduct.specifications
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <h3 class="info-title">入库信息</h3>
        <el-row>
          <el-col :span="12">
            <el-form-item label="批次号：">
              {{ productInfo.productBatchNum }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库数量：">
              {{ productInfo.remark }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="组盘数量：">
              <span>{{productInfo.inStorageNum}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库重量：">
              <span>{{ productInfo.totalWeight }} 吨 </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产日期：">
              {{ productInfo.madeDate | dateformat }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工厂名称：">
              {{ productInfo.companyName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入库单号：" prop="orderNum">
              <span v-if="productInfo.productionProduct">{{
                productInfo.orderNum
              }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库仓库：" prop="">
              <!-- <span v-if="productInfo.productionProduct">{{
                productInfo.orderNum
              }}</span> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="入库日期：" prop="createDate">
              {{ productInfo.createDate | dateformat }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库经手人：" prop="createUserName">
              <span>{{ productInfo.createUserName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="dialogInfo = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  inWarehouseList,
  getAllProductList,
  inFileUpload,
} from "@/common/api.js";
export default {
  data() {
    return {
      listForm: {
        pageNum: 1,
        pageSize: 10,
        data: {
          productBatchNum: "",
          productId: "",
        },
      },
      list: [],
      productName: "",
      productList: [],
      loading: false,
      total: 0,
      dialogInfo: false,
      productInfo: {},
      outHouseDate: null,
    };
  },
  methods: {
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      inWarehouseList(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getProdictList() {
      let params = {
        productName: "",
      };
      getAllProductList(params).then((res) => {
        this.productList = res.data;
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.productList;
      if (queryString == "" || queryString == undefined) {
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants;
        cb(results);
      } else {
        let params = {
          productName: queryString || "",
        };
        getAllProductList(params).then((res) => {
          cb(res.data);
        });
      }
      // 调用 callback 返回建议列表的数据
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.productName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
      this.productName = item.productName;
      this.listForm.data.productId = item.productId;
    },
    //   查询
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    reset() {
      this.$refs["listForm"].resetFields();
      this.listForm = {
        pageNum: 1,
        pageSize: 10,
        data: {
          productBatchNum: "",
          productId: "",
        },
      };
      this.productName = "";
      this.getPageList();
    },
    operationBtn(id, row) {
      this.dialogInfo = true;
      this.$nextTick(() => {
        this.productInfo = row;
      });
    },
    uploadFile(file) {
      console.log(file);
      let formDatas = new FormData();
      formDatas.append("uploadAndParse", file.file);
      inFileUpload(formDatas)
        .then((res) => {
          if (res.errorCode == 200) {
            this.$message({
              type: "success",
              message: "上传成功",
            });
            this.getPageList();
          } else {
            this.$message.error("上传失败，请重试！");
          }
        })
        .catch((err) => console.log(err));
    },
    handleSuccess(res, file, fileList) {
      console.log(res);
    },
    handleAddClose() {
      this.productInfo = {};
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
  },
  mounted() {
    this.getPageList();
    this.getProdictList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }
  .info-title {
    border-left: 3px solid #4da4ca;
    color: #4da4ca;
    text-indent: 15px;
    margin-top: 15px;
  }
  /deep/ .el-autocomplete-suggestion {
    min-width: 100%;
    width: auto !important;
  }
  .dialog-Info /deep/.el-form-item {
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/user/inAndOutWarehouse/inWarehouse.vue